import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import zihuaLogo from "../../../assets/pdfs/zihua-logo.png";
import header from "../../../assets/pdfs/Mask group.png";
import gradient from "../../../assets/pdfs/background2.png";
import { format } from "date-fns";
import { formattedPrice } from "../../../utils";

Font.register({ family: "Avenir", src: "./Avenir Regular.ttf" });
// Estilos para el comprobante
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
  },
  sectionHeader: {
    height: "15%",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "8%",
    justifyContent: "center",
    alignItems: "center",
  },
  headerBackground: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  logo: {
    position: "absolute",
    width: "100px",
    height: "100px",
  },
  content: {
    marginTop: 10,
    marginVertical: 20,
  },
  textFooter: {
    color: "white",
    marginVertical: 5,
  },
  signatureLine: {
    width: "86.5%",
    height: 1,
    backgroundColor: "black",
    marginBottom: 5,
  },
});

// Componente del documento
const PaymentReceipt = (props) => {
  const paymentPending =
    parseFloat(props.remainingAmount) - parseFloat(props.amount);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.sectionHeader}>
          <Image src={gradient} style={styles.headerBackground} />
          <Image src={header} style={styles.headerBackground} />
          <Image src={zihuaLogo} style={styles.logo} />
        </View>
        <View style={styles.content}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginHorizontal: 40,
            }}
          >
            <View style={{ flexDirection: "column" }}>
              <View
                style={{
                  flexDirection: "row",
                  paddingVertical: 5,
                  alignItems: "center",
                  alignSelf: "center",
                }}
              >
                <Text style={{ fontSize: 12 }}>Cliente: </Text>
                <Text style={{ fontSize: 9, marginLeft: 5 }}>
                  {props.fullName}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  paddingVertical: 5,
                  alignItems: "center",
                }}
              >
                <Text style={{ fontSize: 12 }}>Fecha: </Text>
                <Text style={{ fontSize: 9, marginLeft: 5 }}>
                  {format(new Date(), "dd/MM/yyyy")}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  paddingVertical: 5,
                  alignItems: "center",
                }}
              >
                <Text style={{ fontSize: 12 }}>Terreno: </Text>
                <Text style={{ fontSize: 9, marginLeft: 5 }}>
                  {props?.landName || "Sin nombre"}
                </Text>
              </View>
            </View>
            <View style={{ alignItems: "flex-end" }}>
              <Text style={{ fontSize: 12 }}>ZIHUA INVESTMENTS</Text>

              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 5,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 8, marginLeft: 5 }}>
                  calle 13 # 10 - 32
                </Text>
                <Text style={{ fontSize: 8, marginLeft: 5 }}>3118428832</Text>
                <Text style={{ fontSize: 8, marginLeft: 5 }}>
                  info@zihuainvest.com
                </Text>
              </View>
            </View>
          </View>

          <View style={{ height: "20px", marginTop: 20 }}>
            <Image src={gradient} style={styles.headerBackground} />
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                position: "absolute",
                alignItems: "center",
                justifyContent: "space-between",
                color: "white",
                marginHorizontal: 40,
              }}
            >
              <Text style={{ fontSize: 12 }}>Comprobante de Pago</Text>
              <Text
                style={{
                  fontSize: 8,
                  marginHorizontal: 80,
                  alignItems: "center",
                }}
              >
                {props?.operationNumber || "000"}
              </Text>
            </View>
          </View>

          <View style={{ alignItems: "flex-end" }}>
            <View
              style={{
                flexDirection: "row",
                marginHorizontal: 40,
                alignItems: "flex-end",
              }}
            >
              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 15,
                  paddingLeft: 15,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 10 }}>Concepto:</Text>
                <Text style={{ fontSize: 8, marginTop: 25 }}>
                  Pago de servicios
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 15,
                  paddingLeft: 15,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 10 }}>Monto a pagar:</Text>
                <Text style={{ fontSize: 8, marginTop: 25 }}>
                  {formattedPrice(props?.amount || "333.45")}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 15,
                  paddingLeft: 15,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 10 }}>Número de operación:</Text>
                <Text style={{ fontSize: 8, marginTop: 25 }}>
                  {props?.operationNumber || "000"}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 15,
                  paddingLeft: 15,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 10 }}>Monto actual:</Text>
                <Text style={{ fontSize: 8, marginTop: 25 }}>
                  {formattedPrice(props?.remainingAmount || "000")}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "column",
                  paddingVertical: 15,
                  paddingLeft: 15,
                  alignItems: "flex-end",
                }}
              >
                <Text style={{ fontSize: 10 }}>Fecha de vencimiento:</Text>
                <Text style={{ fontSize: 8, marginTop: 25 }}>
                  {props?.paymentDate || "2025-03-10"}
                </Text>
              </View>
            </View>
          </View>

          <View
            style={[
              styles.signatureLine,
              { marginHorizontal: 40, marginTop: 5 },
            ]}
          />

          <View
            style={{
              flexDirection: "column",
              alignItems: "flex-end",
              marginHorizontal: 40,
            }}
          >
            <View style={{ flexDirection: "row", paddingVertical: 5 }}>
              <Text style={{ fontSize: 12 }}>Total Pagado</Text>
              <Text
                style={{ fontSize: 10, marginLeft: 5, alignItems: "center" }}
              >
                {formattedPrice(props?.paymentAmount || "0")}
              </Text>
            </View>

            <View style={{ flexDirection: "column", alignItems: "flex-end" }}>
              <Text style={{ fontSize: 12 }}>{formattedPrice(paymentPending)}</Text>
            </View>
          </View>
        </View>

        <View style={{ marginHorizontal: 40, bottom: -270 }}>
          <Text style={{ fontSize: "14px", paddingTop: 20 }}>
            Este comprobante sirve como constancia del monto recibido. Para
            cualquier duda o aclaración, favor de contactarnos.
          </Text>
        </View>

        <View style={styles.sectionFooter}>
          <Image src={gradient} style={styles.headerBackground} />
          <Text style={styles.textFooter}>zihuainvest.com</Text>
          <Text style={styles.textFooter}>info@zihuainvest.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default PaymentReceipt;
